<template>
  <div :class="['dr-text-field-spilka-ui-kit', { 'is-exceed': typeof required === 'string' }, { 'is-disabled': disabled }]">
    <div v-if="prependIcon" class="dr-text-field-spilka-ui-kit__prepend-icon">
      <v-icon @click="onIconClick">{{ prependIcon }}</v-icon>
    </div>
    <div v-if="prependInnerIcon" class="dr-text-field-spilka-ui-kit__prepend-inner-icon">
      <v-icon @click="onIconClick">{{ prependInnerIcon }}</v-icon>
    </div>
    <label
      :for="inputId"
      :class="[{ 'dr-text-field-spilka-ui-kit__label-with-empty-value': labelPosition }, { 'dr-text-field-spilka-ui-kit__label-have-value': value }]"
    >
      {{ label }}
      <span v-if="rules.length > 0" class="dr-text-field-required-hint">*</span>
    </label>
    <input
      :id="inputId"
      :tabindex="tabindex"
      :class="[
        'dr-text-field-spilka-ui-kit__inner',
        { 'dr-text-field-spilka-ui-kit__input-prepend-inner-icon': prependInnerIcon },
        { 'dr-text-field-spilka-ui-kit__input-prepend-icon': prependIcon },
        { 'dr-text-field-spilka-ui-kit__suffix-inner-input': appendOuterIcon },
      ]"
      :disabled="disabled"
      :readonly="readonly"
      :type="type"
      :value="value"
      @input="onInput"
      @keyup="onKeyUp"
      @change="onChange"
    />
    <div
      v-if="clearable"
      :class="[
        'dr-text-field-spilka-ui-kit__clearable',
        { 'dr-text-field-spilka-ui-kit__clearable-number-and-append-icon': type === 'number' && appendIcon },
        { 'dr-text-field-spilka-ui-kit__clearable-number': type === 'number' && appendOuterIcon },
      ]"
    >
      <v-icon @click="onClear">mdi-close</v-icon>
    </div>
    <div
      v-if="appendIcon"
      :class="[
        'dr-text-field-spilka-ui-kit__suffix',
        { 'dr-text-field-spilka-ui-kit__suffix-number': type === 'number' },
        { 'dr-text-field-spilka-ui-kit__suffix-show-password': appendIcon === 'mdi-eye' || 'mdi-eye-off' },
      ]"
      @click="onIconClick"
    >
      <v-icon>{{ appendIcon }}</v-icon>
    </div>
    <div v-if="appendOuterIcon" class="dr-text-field-spilka-ui-kit__suffix-inner" @click="onIconClick">
      <v-icon>{{ appendOuterIcon }}</v-icon>
    </div>
    <div v-if="typeof required === 'string'">
      <span class="dr-text-field-spilka-ui-kit-error-span">{{ label }} {{ required }}</span>
    </div>
  </div>
</template>

<script>
import '../../tools/style/dr-text-field-spilka-ui-kit.scss'
export default {
  props: {
    tabindex: {
      type: Number,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    label: {
      Type: String,
      required: false,
      default: ''
    },
    prependIcon: {
      type: String,
      required: false,
      default: ''
    },
    prependInnerIcon: {
      type: String,
      required: false,
      default: ''
    },
    appendIcon: {
      type: String,
      required: false,
      default: ''
    },
    appendOuterIcon: {
      type: String,
      required: false,
      default: ''
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    required: false
  }),
  computed: {
    labelPosition() {
      if (typeof this.value === 'number' && this.value === 0) {
        return false
      }

      if (!this.value) {
        return true
      }

      return false
    },
    inputId() {
      return new Date().getTime().toString(36) + Math.random().toString(36).slice(2)
    }
  },
  methods: {
    isRequired(val) {
      return (val || '').length > 0 || `${this.label} - ${this.$t('drTestField.required')}`
    },
    onClear() {
      this.$emit('input', undefined)
    },
    onInput(event) {
      if (this.rules.length > 0) {
        const ruleResult = this.rules[0](event.target.value)

        this.required = ruleResult
      }
      this.$emit('input', event.target.value)
    },
    onIconClick() {
      this.$emit('onIconClick')
    },
    onKeyUp(event) {
      this.$emit('keyup', event)
    },
    onChange(event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>